import fr from 'date-fns/locale/fr';
import de from 'date-fns/locale/de';
import es from 'date-fns/locale/es';
import en from 'date-fns/locale/en-US';
import it from 'date-fns/locale/it';
import pt from 'date-fns/locale/pt';
import varFlag from './assets/img/flags/var.svg';
import frFlag from './assets/img/flags/fr.svg';
import deFlag from './assets/img/flags/de.svg';
import enFlag from './assets/img/flags/en.svg';
import itFlag from './assets/img/flags/it.svg';
import esFlag from './assets/img/flags/es.svg';
import ptFlag from './assets/img/flags/pt.svg';
import nlFlag from './assets/img/flags/nl.svg';

export const languages = [
  { id: 'b0111406-44b7-4dd8-be81-43914ec2b62e', language_iso2: 'fr' },
  { id: 'd1cc1d31-ce08-4f19-8efc-5ca65880c43b', language_iso2: 'es' },
  { id: '7104cb7f-9491-410a-9d36-2ee75d38ff2d', language_iso2: 'it' },
  { id: 'a6c0190d-88b3-42a3-8d2d-b6bd5520eedc', language_iso2: 'pt' },
  { id: 'beb9ef98-9a20-4a56-9abb-8e9c2979ba19', language_iso2: 'en' },
  { id: '72d280d4-bf12-4a51-aa2e-796c90563426', language_iso2: 'nl' },
  { id: '2f5de7f7-b67c-4309-a34e-33e07f6237e8', language_iso2: 'de' },
];

export const calendarLang = {
  FR: fr,
  DE: de,
  ES: es,
  IT: it,
  PT: pt,
  EN: en,
};

export const country = {
  1: 'fr',
  2: 'de',
  7: 'es',
  3: 'it',
  8: 'pt',
  9: 'nl',
};

export const flags = {
  var: varFlag,
  fr: frFlag,
  de: deFlag,
  en: enFlag,
  it: itFlag,
  es: esFlag,
  pt: ptFlag,
  nl: nlFlag,
};
// export const LanguageContext = React.createContext(
//   languages.fr, // default value
// );
